import shape02 from "../../../Assets/img/shape02.svg";
import shape05 from "../../../Assets/img/shape05.svg";
import shape06 from "../../../Assets/img/shape06.svg";
import shape07 from "../../../Assets/img/shape07.svg";
import figura03 from "../../../Assets/img/figura03.svg";
import icoManager from "../../../Assets/img/ico-manager.svg";
import { NoticiasSlider } from '../Components/NoticiasSlider';
import { home_novedades } from '../diccionario';
import useSEOConfig from '../../../hooks/seo/useSEOConfig';
import { Navbar } from '../Components/Navbar';
import { useConfig } from "../../../context/ConfigContext";
import { Link, useLocation } from "react-router-dom";
import { buscarTextoSeo } from "../../../utils/buscarTextoSeo";

type CountryCode = "AR" | "UY" | "BR";

type FaqItem = {
    question: Record<CountryCode, string>;
    answer: Record<CountryCode, JSX.Element | null>;
};

type FaqData = {
    title: string;
    items: FaqItem[];
};

const accordionData: FaqData[] = [
    {
        title: "SOBRE NOSOTROS",
        items: [
            {
                question: {
                    "AR": "¿Quiénes somos?",
                    "UY": "¿Quiénes somos?",
                    "BR": "¿Quiénes somos?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Somos un bróker integral digital de seguros, acompañamos a nuestros clientes en todo el proceso de cotización, comparación de coberturas, y contratación de seguros.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Ofrecemos una amplia variedad de seguros para individuos y empresas, entre ellos; auto, moto, hogar, prepaga médica, ART, AP, agro, caución, embarcación y muchos más. Sea cual sea tu necesidad, estamos aquí para ayudarte a encontrar la mejor opción.</p>
                    </>,
                    "UY":
                        <>
                            <p className="fs-15 fs-lg-16 lh-16 mb-20">Somos un corredor integral digital de seguros. Acompañamos a nuestros clientes en todo el proceso de cotización, comparación de coberturas y contratación.</p>
                            <p className="fs-15 fs-lg-16 lh-16 mb-20">Ofrecemos una amplia variedad de seguros para individuos y empresas: auto, moto, hogar, garantía de alquiler, caución, integral de comercio y muchos más. Sea cual sea tu necesidad, estamos para ayudarte a encontrar la mejor opción.</p>
                        </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Dónde nos encontrás?",
                    "UY": "¿Dónde nos encontrás?",
                    "BR": "¿Dónde nos encontrás?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Tenemos a disposición todos nuestros canales digitales para que nos escribas desde la comodidad de tu casa, oficina, mientras viajas, ¡de dónde sea! Contactános por:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>WhatsApp: <a href="https://wa.me/5491128357048" target="_blank" rel='noreferrer' className="text-decoration-underline">+54 9 11 2835-7048</a></li>
                            <li>Teléfono:&nbsp;<a href="tel:08104447348" target="_blank" rel='noreferrer' className="text-decoration-underline">0810-444-7348</a></li>
                        </ul>

                        <p className="fs-15 fs-lg-16 lh-16 mb-0">Además si sos cliente lo podés hacer desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-0">Horarios:</p>
                        <ul className="fs-15 fs-lg-16 lh-16">
                            <li>Ventas: lunes a viernes de 08:30 a 20:30hs. </li>
                            <li>Atención al cliente: lunes a viernes de 09:00 a 18:00hs.</li>
                        </ul>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Podés contactarnos desde donde quieras por nuestros canales digitales.</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>WhatsApp: <a href="https://wa.me/59892281806" target="_blank" rel='noreferrer' className="text-decoration-underline">+598 9228-1806.</a></li>
                        </ul>

                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Además si sos cliente lo podés hacer desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-0">Horarios:</p>
                        <ul className="fs-15 fs-lg-16 lh-16">
                            <li>Ventas: lunes a viernes de 08:30 a 20:30 hs.</li>
                            <li>Atención al cliente: lunes a viernes hábiles de 09:00 a 17:00 hs.</li>
                        </ul>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Por qué elegirnos?",
                    "UY": "¿Por qué elegirnos?",
                    "BR": "¿Por qué elegirnos?"
                },
                answer: {
                    "AR": <p className="fs-15 fs-lg-16 lh-16 mb-20">Simplificamos todos tus trámites y te acercamos la mejor propuesta. Ofrecemos servicios antes, durante y después de la contratación, que incluyen asistencia en emisiones de pólizas, gestión de cobranzas y sinestros. Estamos comprometidos en brindarte continuo soporte y que tengas la mejor experiencia aseguradora junto a nosotros.</p>,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Simplificamos todos tus trámites y te acercamos la mejor propuesta. Te acompañamos antes, durante y después de la contratación: emisión de pólizas, gestión de cobranzas y siniestros. Estamos comprometidos en darte soporte continuo.</p>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Con qué compañías trabajamos?",
                    "UY": "¿Con qué compañías trabajamos?",
                    "BR": "¿Con qué compañías trabajamos?",
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Tenemos la mayor y mejor oferta aseguradora online conectada a nuestros servidores en real time. Reconocidas por su trayectoria y respaldo. ​</p>
                        <ul className="fs-15 fs-lg-16 lh-16">
                            <li>Sancor Seguros</li>
                            <li>Experta</li>
                            <li>Mercantil Andina</li>
                            <li>Provincia</li>
                            <li>San Cristobal</li>
                            <li>Allianz</li>
                            <li>Zurich</li>
                            <li>Galicia Seguros</li>
                            <li>Mapfre</li>
                            <li>La Meridional</li>
                            <li>Integrity</li>
                            <li>SMG</li>
                            <li>Chubb</li>
                            <li>Prevención Salud</li>
                            <li>Federación Patronal</li>
                            <li>Berkley</li>
                            <li>Galeno</li>
                            <li>Cruz Suiza</li>
                            <li>Seguros Rivadavia</li>
                        </ul>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Tenemos la mayor y mejor oferta aseguradora online, conectada en tiempo real con nuestras plataformas. Algunas compañías:</p>
                        <ul className="fs-15 fs-lg-16 lh-16">
                            <li>BSE</li>
                            <li>Sura</li>
                            <li>Mapfre</li>
                            <li>San Cristobal</li>
                            <li>Porto Seguro</li>
                            <li>Barbuss</li>
                            <li>Sancor Seguros</li>
                        </ul>
                    </>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "AUTOGESTIÓN MI SEGURARSE",
        items: [
            {
                question: {
                    "AR": "¿Qué puedo hacer desde Mi Segurarse?",
                    "UY": "¿Qué puedo hacer desde MI SEGURARSE?",
                    "BR": "¿Qué puedo hacer desde la App?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Gestioná tu seguro estés donde estés, las 24 horas, los 7 días de la semana. Desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> podés:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Ver y descargar tus pólizas</li>
                            <li>Denunciar un siniestro</li>
                            <li>Hacer seguimiento de tus consultas</li>
                            <li>Solicitar asistencia mecánica</li>
                            <li>Modificar tu medio de pago</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Y mucho más!</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Gestioná tu seguro estés donde estés, las 24 horas, los 7 días de la semana. Desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> podés:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Ver y descargar tus pólizas</li>
                            <li>Denunciar un siniestro</li>
                            <li>Hacer seguimiento de tus consultas</li>
                            <li>Solicitar asistencia mecánica</li>
                            <li>Modificar tu medio de pago</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Y mucho más!</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cómo ingreso?",
                    "UY": "¿Cómo ingreso?",
                    "BR": "¿Cómo descargo la App?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">¡Muy fácil! En solo unos pasos:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Ingresá a <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a></li>
                            <li>Escribí tu mail y hacé clic en Ingresar</li>
                            <li>Revisá tu casilla y hacé clic en el link que te enviamos</li>
                            <li>Si es tu primera vez, ingresá tu número de documento para confirmar tu identidad</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Listo! Ya podés gestionar tu seguro desde cualquier lugar.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">¡Muy fácil! En solo unos pasos:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Ingresá a <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a></li>
                            <li>Escribí tu mail y hacé clic en Ingresar</li>
                            <li>Revisá tu casilla y hacé clic en el link que te enviamos</li>
                            <li>Si es tu primera vez, ingresá tu cédula de identidad para validar</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Listo! Ya podés gestionar tu seguro desde cualquier lugar.</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cómo me registro?",
                    "UY": "¿Cómo me registro?",
                    "BR": "¿Cómo me registro?"
                },
                answer: {
                    "AR": null,
                    "UY": null,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "SOBRE MI PÓLIZA Y COBERTURA",
        items: [
            {
                question: {
                    "AR": "Ya contraté mi seguro, ¿cuándo se hace efectiva la cobertura?",
                    "UY": "Ya contraté mi seguro, ¿cuándo se hace efectiva la cobertura?",
                    "BR": "Ya contraté mi seguro, ¿cuándo se hace efectiva la cobertura?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">La cobertura no comienza en la fecha en que solicitas la cotización o completas la solicitud de seguro, sino en la <b>fecha de inicio que se establece en la póliza</b>.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Tené en cuenta que, en algunos casos, la emisión de la póliza puede requerir inspección. Una vez que la inspección se realice y la aseguradora elegida la confirme, estarás seguro.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">No te preocupes, que una vez que la inspección sea aprobada, te enviaremos la póliza a tu mail y ya estarás asegurado.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">La cobertura empieza en la fecha indicada en la póliza (no cuando la solicitás). En algunos casos se requiere inspección previa del vehículo. Una vez aprobada, te mandamos la póliza por mail y ya quedás asegurado.</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cuánto demora la emisión de póliza?",
                    "UY": "¿Cuánto demora la emisión de póliza?",
                    "BR": "¿Cuánto demora la emisión de póliza?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">El tiempo para emitir una póliza de seguro varía de acuerdo a diversos factores.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">En el caso de las pólizas de automotor que requieren una inspección vehicular, el proceso puede demorar hasta 96 horas una vez aprobada la inspección por la compañía aseguradora.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Nuestro objetivo en Segurarse es garantizar que obtengas una cobertura completa y precisa, por lo que la inspección vehicular es una parte importante de este proceso.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Depende del caso. Si requiere inspección, puede tardar hasta 96 horas después de aprobada. Nuestro objetivo es darte una cobertura completa y segura.</p>
                    </>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "MI DOCUMENTACIÓN",
        items: [
            {
                question: {
                    "AR": "¿Qué documentación necesito para circular?",
                    "UY": "¿Qué documentación necesito para circular?",
                    "BR": "¿Qué documentación necesito para circular?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Para transitar con tu vehículo debés llevar con vos:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Licencia de conducir</li>
                            <li>Documento de identidad</li>
                            <li>Verificación técnica vehicular</li>
                            <li>Oblea de Gas (según corresponda)</li>
                            <li>Tarjeta de circulación y/o póliza vigente (si sos cliente nuestro, los encontrás en <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>)</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">En el caso de circular por países del Mercosur, es necesario contar con el certificado de Mercosur. </p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Para transitar con tu vehículo debés llevar con vos:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Licencia de conducir</li>
                            <li>Libreta del vehículo</li>
                            <li>Comprobante de SOA</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Si vas a circular por Mercosur, también necesitás el certificado correspondiente.</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Dónde puedo descargar mi póliza?",
                    "UY": "¿Dónde descargo mi póliza?",
                    "BR": "¿Dónde puedo descargar mi póliza?"
                },
                answer: {
                    "AR": <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Es muy fácil! Para descargar tu póliza, ingresá a <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>, hacé clic en "Ver detalle" dentro de la póliza que desees, y luego hacé clic en "Descargar póliza".</p>,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>, entrá a la póliza, hacé clic en "Ver más" y luego "Descargar documentación".</p>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "Veo errores en mi póliza ¿cómo los modifico?",
                    "UY": "¿Veo errores en mi póliza, ¿cómo los modifico?",
                    "BR": "Veo errores en mi póliza ¿cómo los modifico?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Si detectás errores en la emisión de tu póliza, ingresá a <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>, hacé clic en "Gestiones", luego tocá el botón de "Nueva gestión" y elegí "Modificar datos de la póliza". Es importante adjuntar la documentación respaldatoria. Si precisás más asesoramiento contactanos a través de nuestros <a href="/contacto" className="text-decoration-underline">canales de atención</a>.</p>
                    </>,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Contactanos por WhatsApp <a href="https://wa.me/59892281806" target="_blank" rel='noreferrer' className="text-decoration-underline">+598 9228-1806.</a> y te ayudamos.</p>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "No veo la renovación de mi póliza ¿qué hago?",
                    "UY": "Quiero renovar mi póliza",
                    "BR": ""
                },
                answer: {
                    "AR": <><p className="fs-15 fs-lg-16 lh-16 mb-20">En <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>, en la sección de Pólizas, podrás encontrar la póliza y verificar su vigencia. En caso que esté vencida, comunicate con nosotros para renovar tu cobertura.</p></>,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Se renueva automáticamente al año si las cuotas están al día. Recibís la nueva póliza por mail.</p>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "No quiero renovar",
                    "UY": "No quiero renovar",
                    "BR": ""
                },
                answer: {
                    "AR": null,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Podés pedir la no renovación en el mes en que se renueva. La fecha figura en tu póliza.</p>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "Quiero dar de baja",
                    "UY": "Quiero dar de baja",
                    "BR": ""
                },
                answer: {
                    "AR": null,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Debés contactarte con un asesor. Recordá que dar de baja antes del año puede tener costos.</p>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "CÓMO CONTRATAR Y EMITIR UN SEGURO",
        items: [
            {
                question: {
                    "AR": "¿Cómo contratar un seguro?",
                    "UY": "¿Cómo contratar un seguro?",
                    "BR": "¿Cómo contratar un seguro?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">En Segurarse, podés contratar el seguro que estás buscando sin moverte de tu casa. Tenemos seguros <a href="/seguros-individuos" className="text-decoration-underline">para Individuos</a> y <a href="/seguros-corporativos" className="text-decoration-underline">para Empresas</a></p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Sólo debes ingresar unos pocos datos para que podamos cotizar tu seguro, y te acercarte las mejores propuestas del mercado que se adapten a vos.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">También, podés <a href="/contacto" className="text-decoration-underline">comunicarte con nosotros aquí</a> y te asesoramos para que puedas tomar una decisión inteligente.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Podés hacerlo 100% online. Ingresás tus datos, cotizamos y te damos las mejores opciones del mercado. También podés contactarnos para asesoramiento personalizado.</p>
                    </>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "FACTURACIÓN Y ESTADO DE CUENTAS",
        items: [
            {
                question: {
                    "AR": "¿Cuáles son los medios de pago disponibles?",
                    "UY": "¿Cuáles son los medios de pago disponibles?",
                    "BR": "¿Cuáles son los medios de pago disponibles?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Contás con los siguientes medios de pago:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Tarjeta de Crédito.</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Los medios de pago están sujetos a los términos y condiciones de la contratación de la póliza.</p>
                    </>,
                    "UY": <>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Tarjeta de crédito (Visa, Mastercard, OCA).</li>
                            <li>Tarjeta de Debito.</li>
                            <li>Abitab (con número de cédula)</li>
                            <li>Red Pagos (con número de cédula).</li>
                        </ul>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cómo puedo verificar si tengo deuda?",
                    "UY": "¿Cómo puedo verificar si tengo deuda?",
                    "BR": "¿Cómo puedo verificar si tengo deuda?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">En caso de tener algun pago rechazado, en <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> tu póliza va a aparecer con un mensaje de advertencia y los pasos a seguir para regularizar el pago.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">De todos modos, ¡no te procupes! Si se rechaza algun pago de tu cuenta, nos comunicaremos con vos por mail y por WhatsApp para regularizar el saldo pendiente.</p>
                    </>,
                    "UY": <><p className="fs-15 fs-lg-16 lh-16 mb-20">Contactanos por cualquiera de nuestros canales y lo verificamos.</p></>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "INSPECCIÓN DE VEHÍCULO",
        items: [
            {
                question: {
                    "AR": "¿Cómo hago la inspección de mi vehículo?",
                    "UY": "¿Cómo hago la inspección de mi vehículo?",
                    "BR": "¿Cómo hago la inspección de mi vehículo?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Realizar la inspección de tu vehículo es muy fácil; podes enviar las fotos solicitadas a través de <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> o a nuestro WhatsApp:{" "}
                            <a href="https://wa.me/5491128357048" target="_blank" rel='noreferrer' className="text-decoration-underline">+54 9 11 2835-7048.</a></p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Para la inspección, las fotos de tu vehículo deben seguir estas condiciones:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Tomarse el mismo día y lugar</li>
                            <li>Sacarse con formato horizontal y tener buena iluminación</li>
                            <li>Tener buena legibilidad cuándo sean documentos</li>
                            <li>Fechadas según correponda</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Te compartimos un breve  <a href="https://youtube.com/shorts/yJMN_36qT90" target="_blank" rel='noreferrer'
                            className="text-decoration-underline">vídeo con ejemplos</a>.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Podés enviar las fotos por <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> o por WhatsApp:
                            <a href="https://wa.me/59892281806" target="_blank" rel='noreferrer' className="text-decoration-underline">+598 9228-1806.</a></p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Requisitos:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Sacar fotos el mismo día y en el mismo lugar.</li>
                            <li>Formato horizontal y buena iluminación.</li>
                            <li>Documentos legibles y fechados correctamente.</li>
                        </ul>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Te compartimos un breve  <a href="https://youtube.com/shorts/yJMN_36qT90" target="_blank" rel='noreferrer'
                            className="text-decoration-underline">vídeo con ejemplos</a>.</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Qué pasa si me piden foto de la rueda de auxilio y no tengo la rueda?",
                    "UY": "",
                    "BR": "¿Qué pasa si me piden foto de la rueda de auxilio y no tengo la rueda?"
                },
                answer: {
                    "AR": <p className="fs-15 fs-lg-16 lh-16 mb-20">En ese caso, debes enviarnos la foto del espacio contenedor de la rueda de auxilio vacio.</p>,
                    "UY": null,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cuánto tiempo tengo para hacer la inspección?",
                    "UY": "¿Cuánto tiempo tengo para hacer la inspección?",
                    "BR": "¿Cuánto tiempo tengo para hacer la inspección?"
                },
                answer: {
                    "AR": <p className="fs-15 fs-lg-16 lh-16 mb-20">La inspección se debe realizar lo antes posible ya que la cobertura elegida iniciará una vez que la inspección sea aprobada por la compañía aseguradora.</p>,
                    "UY": <p className="fs-15 fs-lg-16 lh-16 mb-20">Hacela lo antes posible. La cobertura comienza una vez aprobada. </p>,
                    "BR": null
                }
            }
        ]
    },
    {
        title: "DENUNCIAR SINIESTRO Y SOLICITAR ASISTENCIA",
        items: [
            {
                question: {
                    "AR": "¿Qué debo hacer si tuve un siniestro?",
                    "UY": "¿Qué hago si tuve un siniestro?",
                    "BR": "¿Qué debo hacer si tuve un siniestro?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">En en caso de tener un siniestro, podés hacer la denuncia administrativa por <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> ingresando a la sección "Siniestros", tendrás un paso a paso que te guiará en la denuncia del mismo.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">También, podés realizar la denuncia administrativa de lunes a viernes de 9:00 a 18:00hs a través de nuestro WhatsApp <a href="https://wa.me/5491128357048" target="_blank" rel='noreferrer' className="text-decoration-underline">+54 9 11 2835-7048</a> o comunicándote al <a href="tel:08104447348" target="_blank" rel='noreferrer' className="text-decoration-underline">0810-444-7348</a> (opción 2).</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Primero, denunciá a tu aseguradora. Después avisanos para el seguimiento. Estamos de lunes a viernes de 9:00 a 17:00 hs por WhatsApp <a href="https://wa.me/59892281806" target="_blank" rel='noreferrer' className="text-decoration-underline">+598 9228-1806.</a></p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cómo puedo ver el estado de un siniestro?",
                    "UY": "",
                    "BR": ""
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Es muy fácil! En la sección "Siniestros" dentro de <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> podrás visualizar la información de los siniestros denunciados y el estado actual de los mismos.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">De todos modos, nuestro equipo se va a comunicar con vos para mantenerte informado de todas las novedades.</p>
                    </>,
                    "UY": null,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cuáles son los datos que tengo que presentar para denunciar un choque con otra persona?",
                    "UY": "¿Qué datos necesito para denunciar un choque con otra persona?",
                    "BR": "¿Cuáles son los datos que tengo que presentar para denunciar un choque con otra persona?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Para realizar la denuncia vamos a necesitar que nos indiques:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Fecha, hora y lugar del hecho</li>
                            <li>Datos de los terceros involucrados. Sus datos personales (nombre completo, teléfono y mail) y los datos del vehículo (patente, tipo de seguro y compañía aseguradora)</li>
                        </ul>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-10">Para realizar la denuncia vas a tener que indicar:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Fecha, hora y lugar.</li>
                            <li>Datos de los involucrados: nombre, teléfono, mail, auto y compañía de seguros.</li>
                        </ul>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "Me robaron las ruedas, ¿qué debo hacer?",
                    "UY": "",
                    "BR": ""
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Lamentamos escuchar eso! Pero no te preocupes, te vamos a ayudar en todo el proceso de reclamo. Primero necesitamos que saques fotos de la unidad y realices la denuncia policial correspondiente.</p>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Una vez que tengas esta información, podes denunciar el siniestro desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> en la sección "Siniestros" o a través de nuestros <a href="/contacto" className="text-decoration-underline">canales de atención</a>.</p>
                    </>,
                    "UY": null,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "Me robaron el auto, ¿qué debo hacer?",
                    "UY": "Me robaron el auto. ¿Qué hago?",
                    "BR": "Me robaron el auto, ¿qué debo hacer?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">¡Lamentamos escuchar eso! Pero no te preocupes, te vamos a ayudar en todo el proceso de reclamo. Para poder hacerlo, una vez que hayas hecho la denuncia policial, necesitamos que nos envíes la información del siniestro a través de <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a> en la sección "Siniestros", o a través de nuestros <a href="/contacto" className="text-decoration-underline">canales de atención</a>.</p>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Después de la denuncia policial, hacé la administrativa con la aseguradora. Avisanos para el seguimiento.</p>
                    </>,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Cómo realizo una denuncia por granizo?",
                    "UY": "",
                    "BR": ""
                },
                answer: {
                    "AR": <p className="fs-15 fs-lg-16 lh-16 mb-20">Podés hacerlo a través de <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>, ingresás a la sección "Siniestros" e informás lo ocurrido completando los campos requeridos o a través de nuestros <a href="/contacto" className="text-decoration-underline">canales de atención</a>.</p>,
                    "UY": null,
                    "BR": null
                }
            },
            {
                question: {
                    "AR": "¿Dónde me contacto si necesito ayuda mecánica?",
                    "UY": "¿Dónde me contacto si necesito ayuda mecánica?",
                    "BR": "¿Dónde me contacto si necesito ayuda mecánica?"
                },
                answer: {
                    "AR": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Para solicitar asistencia mecánica, podés hacerlo ingresando desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>; hace clic en "Ver más" sobre la póliza del vehículo que necesite atención, luego hacé clic en "Pedir asistencia". También te dejamos a continuación los números de teléfono para comunicarte con tu compañía aseguradora:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>Allianz: 0800-888-24324/37</li>
                            <li>Sancor: 0800-222-8887</li>
                            <li>Provincia: 0800-333-2020</li>
                            <li>Experta: 0800-777-7278</li>
                            <li>Mapfre: 0810-666-7427</li>
                            <li>Zurich: 0800-222-1600</li>
                            <li>Galicia Seguros: 0800-999-76925</li>
                            <li>Galeno: 0800-777-5433</li>
                            <li>Mercantil: 0800-777-2634</li>
                            <li>Meridional: 0800-333-4358</li>
                            <li>Integrity: 0800-222-3700</li>
                            <li>Libra: 0800-999-6500</li>
                            <li>SMG: 0810-333-3764</li>
                            <li>Seguros Rivadavia: 0800-666-6789</li>
                        </ul>
                    </>,
                    "UY": <>
                        <p className="fs-15 fs-lg-16 lh-16 mb-20">Para solicitar asistencia mecánica, podés hacerlo ingresando desde <a href="/autogestion/ingreso" className="text-decoration-underline"><b>Mi Segurarse</b></a>; hacé clic en "Ver más" sobre la póliza del vehículo que necesite atención, luego hacé clic en "Pedir asistencia". También te dejamos a continuación los números de teléfono para comunicarte con tu compañía aseguradora:</p>
                        <ul className="fs-15 fs-lg-16 lh-16 mb-20">
                            <li>BSE: 0800-1994 (fijo) / *1994 (móvil).</li>
                            <li>Sura: (00598) 2605-9020.</li>
                            <li>Mapfre: 92-727-242.</li>
                            <li>Sancor: 0800-333-2766.</li>
                            <li>San Cristóbal: 0800-8831.</li>
                            <li>Porto Seguro: 2487-8616.</li>
                            <li>Barbuss: 0800-2777.</li>
                        </ul>
                    </>,
                    "BR": null
                }
            }
        ]
    }
];

export const PreguntasFrecuentes = () => {

    const { config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Preguntas frecuentes - Consultá nuestra sección y despejá tus dudas",
            description: textoSeo?.description ?? "Nuestra sección de preguntas frecuentes está a disposición para que tengas toda la información que necesitás a tu alcance y no te quedes con dudas, ¡conocela!",
            tituloCompleto: !!textoSeo,
            keywords:
                config.pais === "UY" ?
                    "Seguros de Auto, Aseguradoras, Cotizar seguro online, App mobile, Contratar seguro, Seguro para auto, Seguro para moto, Cotizador de seguros online"
                    :
                    "Seguros de Auto, Aseguradoras, Seguros ART, Cotizar seguro online, App mobile, Contratar seguro, Seguro para auto, Cotizador de seguros online",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    :
                    "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Nuestra sección de preguntas frecuentes está a disposición para que tengas toda la información que necesitás a tu alcance y no te quedes con dudas, ¡conocela!",
            twitterTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    :
                    "Segurarse - Bróker Integral de Seguros digitales",
            twitterDescription: "Nuestra sección de preguntas frecuentes está a disposición para que tengas toda la información que necesitás a tu alcance y no te quedes con dudas, ¡conocela!"
        }
    )

    return (
        <>
            <Navbar rubro="auto" />
            <main>
                <div className='pb-50 pb-lg-80 position-relative min-vh-100'>
                    <img className="d-none d-lg-block pos02" src={shape02} alt="" />
                    <img className="d-none d-lg-block pos08" src={shape07} alt="" />

                    <div className="pt-45 pb-25 pt-lg-80 pb-lg-60 mb-16 mb-lg-m30 bg-f9">
                        <div className="container">
                            <h1 className="ff-mukta fw-bold fs-30 fs-lg-36 lh-lg-1 text-black text-center text-lg-start mb-10">Preguntas Frecuentes</h1>
                            <p className="fs-16 fs-lg-20 text-black text-center text-lg-start mb-0">¿Cómo te podemos ayudar?</p>
                        </div>
                    </div>

                    <div className='container'>
                        <div className='accordion accordion-faq-topic' id="accordionFaqTopics">

                            {
                                accordionData.map((data, i) => (
                                    <div key={data.title} className="accordion-item border-1 border-primary rounded-10 mb-16">
                                        <h3 className="accordion-header">
                                            <button className="accordion-button rounded-8 collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target={`#collapse` + (i + 1)} aria-expanded="false" aria-controls={`collapse` + (i + 1)}>
                                                {data.title === "AUTOGESTIÓN MI SEGURARSE" 
                                                    ? <img src={icoManager} alt="" className="icon-faq-topic icon-manager-img" />
                                                    : <svg className="svg-icon icon-faq-topic">
                                                        <use href={`#icon-faq-topic-${i + 1}`}></use>
                                                    </svg>
                                                }
                                                <span>{data.title}</span>
                                            </button>
                                        </h3>
                                        <div id={`collapse` + (i + 1)} className="accordion-collapse collapse" data-bs-parent="#accordionFaqTopics">
                                            <div className="accordion-body">
                                                <div className="accordion accordion-flush accordion-faq" id="">

                                                    {
                                                        data.items.map((item, i) => (
                                                            <>
                                                                {item.answer[config.pais] == null ?
                                                                    <></>
                                                                    :
                                                                    <div
                                                                        key={i}
                                                                        className="accordion-item">
                                                                        <h3 className="accordion-header">
                                                                            <button className="accordion-button collapsed" type="button"
                                                                                data-bs-toggle="collapse" data-bs-target={`#collapse` + (i + 1) + "1"} aria-expanded="true" aria-controls={`collapse` + (i + 1) + "1"}>
                                                                                {item.question[config.pais]}
                                                                            </button>
                                                                        </h3>
                                                                        <div id={`collapse` + (i + 1) + "1"} className="accordion-collapse collapse">
                                                                            <div className="accordion-body">
                                                                                {item.answer[config.pais]}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>

                                                        ))
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className="bg-f4 py-30 py-lg-50 position-relative">
                    <img className="d-none d-lg-block pos06" src={shape06} alt="" />
                    <div className="container px-lg-5">
                        <div className="row justify-content-evenly">
                            <div className="col-lg-auto text-center text-lg-start">
                                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-lg-1">¿No resolvimos
                                    <br className="d-sm-none" /> tu consulta?</h2>
                                <p className="fw-bold fs-25 fs-lg-25 text-primary mb-18 mb-lg-0">¡Estamos para vos!</p>
                            </div>
                            <div className="col-lg-auto text-center text-lg-left">
                                <Link
                                    to="/contacto"
                                    className="transition-base d-inline-block w-250p py-12 rounded-3 fs-22 fs-lg-24 fw-bold lh-1 text-center bg-primary bg-lg-gray-dark hover-bg-primary text-white"
                                >
                                    CONTACTO
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-primary pt-30 pb-35 position-relative">
                    <img className="d-none d-lg-block pos07" src={shape05} alt="" />
                    <div className="maxw-730p mx-auto px-20 px-lg-0">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center">Para cada riesgo, <br className="d-sm-none" /> tenemos una solución</h2>
                        <p className="fs-16 fs-lg-20 text-white lh-12 mb-35 text-center">Conocé nuestra amplia variedad de seguros, protegé tu inversión y anticipate a cualquier imprevisto.</p>
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-evenly gap-4 gap-lg-0">
                            <a href="/seguros-individuos" className="transition-base d-inline-block w-250p py-12 rounded-3 bg-gray-dark text-white fs-22 fw-bold lh-1 text-center hover-primary hover-bg-white">INDIVIDUOS</a>
                            <a href="/seguros-corporativos" className="transition-base d-inline-block w-250p py-12 rounded-3 bg-gray-dark text-white fs-22 fw-bold lh-1 text-center hover-primary hover-bg-white">CORPORATIVOS</a>
                        </div>
                    </div>
                </div>


                <div className="bg-f4 pt-50 pb-40 py-lg-0">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="d-none d-lg-block col-lg-6">
                                <img src={figura03} width="351" height="308" alt="" />
                            </div>
                            <div className="col-lg-6 text-center text-lg-start">
                                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 mb-20">¡Sumate a nuestra comunidad!</h2>
                                <ul className="list-inline mb-0">
                                    <li className="list-inline-item"><a href="https://www.facebook.com/segurarse.com.ar/" target='_blank' rel='noreferrer' title="Facebook"><svg className="svg-icon" width="34" height="34"><use xlinkHref="#icon-facebook"></use></svg></a></li>
                                    <li className="list-inline-item"><a href="https://www.instagram.com/segurarse/" target='_blank' rel='noreferrer' title="Instagram"><svg className="svg-icon" width="34" height="34"><use xlinkHref="#icon-instagram"></use></svg></a></li>
                                    <li className="list-inline-item"><a href="https://www.linkedin.com/company/segurarse/?originalSubdomain=ar" target='_blank' rel='noreferrer' title="LinkedIn"><svg className="svg-icon" width="34" height="34"><use xlinkHref="#icon-linkedin"></use></svg></a></li>
                                    <li className="list-inline-item"><a href="https://www.youtube.com/channel/UCwiQfVHEgD5BTo5cFBH-EoA#BeneficiosSegurarse:%20Desde%20un%2020%20y%20hasta%20un%2035%20de%20bonificaci%C3%B3n&utm_term=allianzben--7--none--20-30--ENVIO%20SIMPLE" target='_blank' rel='noreferrer' title="YouTube"><svg className="svg-icon" width="34" height="34"><use xlinkHref="#icon-youtube"></use></svg></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='py-5 mb-4'>
                    <div className='container'>
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-center">Visitá nuestro blog</h2>
                        <p className="fs-16 fs-lg-20 text-center mb-35 mb-lg-45">¡full información interesante!</p>

                        <NoticiasSlider
                            items={home_novedades.filter(novedad => novedad.pais === config.pais)}
                        />
                    </div>
                </div>
            </main>
        </>
    )
}
